import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import Card from '../ui/Card';

export default function SectionBrief({ brief }) {
  if (!brief || !brief.sections) return null;

  // Filter only sections with content
  const sectionsWithContent = Object.entries(brief.sections).filter(
    ([key, section]) => section && section.content && section.content.trim() !== ''
  );

  // If no sections have content, don't render the section at all
  if (sectionsWithContent.length === 0) return null;

  return (
    <section id="brief" className="section-padding bg-secondary-900">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{brief.title}</h2>
          <p className="text-xl text-secondary-200 max-w-3xl mx-auto">{brief.description}</p>
        </motion.div>

        {/* Brief Sections Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-7xl mx-auto">
          {sectionsWithContent.map(([key, section], index) => (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card padding="lg" className="h-full">
                <h3 className="text-2xl font-bold text-white mb-4">{section.title}</h3>
                <div className="prose prose-invert prose-sm max-w-none">
                  <ReactMarkdown
                    components={{
                      p: ({ children }) => <p className="text-secondary-200 mb-3">{children}</p>,
                      strong: ({ children }) => <strong className="text-white font-semibold">{children}</strong>,
                      ul: ({ children }) => <ul className="list-disc list-inside text-secondary-200 mb-3 space-y-1">{children}</ul>,
                      li: ({ children }) => <li className="text-secondary-200">{children}</li>,
                      h1: ({ children }) => <h4 className="text-lg font-bold text-white mt-4 mb-2">{children}</h4>,
                      h2: ({ children }) => <h4 className="text-lg font-bold text-white mt-4 mb-2">{children}</h4>,
                      h3: ({ children }) => <h5 className="text-base font-semibold text-white mt-3 mb-2">{children}</h5>,
                    }}
                  >
                    {section.content}
                  </ReactMarkdown>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
